import React from "react";
import Responsive from "react-responsive";
import { breakpoints } from "../theme";

// React Media Query Components: Wrapper components for media queries
export const DesktopDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.xl - 1} />
);

export const DesktopUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.xl} />
);

export const LaptopDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.lg - 1} />
);

export const LaptopUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.lg} />
);

export const TabletDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.md - 1} />
);

export const TabletUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.md} />
);

export const MobileDown = (props: any) => (
  <Responsive {...props} maxWidth={breakpoints.sm - 1} />
);

export const MobileUp = (props: any) => (
  <Responsive {...props} minWidth={breakpoints.sm} />
);
